import { IcAccessManagement } from './icons/ic-access-management.js';
import { IcActivities } from './icons/ic-activities.js';
import { IcAdmin } from './icons/ic-admin.js';
import { IcAgents } from './icons/ic-agents.js';
import { IcAlerts } from './icons/ic-alerts.js';
import { IcAnalytics } from './icons/ic-analytics.js';
import { IcApplications } from './icons/ic-applications.js';
import { IcAssurance } from './icons/ic-assurance.js';
import { IcBookmarks } from './icons/ic-bookmarks.js';
import { IcCameras } from './icons/ic-cameras.js';
import { IcCellularGateway } from './icons/ic-cellular-gateway.js';
import { IcChangeLog } from './icons/ic-change-log.js';
import { IcChangeWindowNotifications } from './icons/ic-change-window-notifications.js';
import { IcConfiguration } from './icons/ic-configuration.js';
import { IcConnect } from './icons/ic-connect.js';
import { IcContextVisibility } from './icons/ic-context-visibility.js';
import { IcCreateFabric } from './icons/ic-create-fabric.js';
import { IcDesign } from './icons/ic-design.js';
import { IcDestinations } from './icons/ic-destinations.js';
import { IcDocumentation } from './icons/ic-documentation.js';
import { IcDomains } from './icons/ic-domains.js';
import { IcEndpoints } from './icons/ic-endpoints.js';
import { IcEnterpriseName } from './icons/ic-enterprise-name.js';
import { IcExplore } from './icons/ic-explore.js';
import { IcFabrics } from './icons/ic-fabrics.js';
import { IcFeedback } from './icons/ic-feedback.js';
import { IcFilters } from './icons/ic-filters.js';
import { IcFirewall } from './icons/ic-firewall.js';
import { IcFirmware } from './icons/ic-firmware.js';
import { IcGenerateToken } from './icons/ic-generate-token.js';
import { IcGlobalOverview } from './icons/ic-global-overview.js';
import { IcGroups } from './icons/ic-groups.js';
import { IcHelp } from './icons/ic-help.js';
import { IcHome } from './icons/ic-home.js';
import { IcIdentity } from './icons/ic-identity.js';
import { IcIndicator } from './icons/ic-indicator.js';
import { IcIntegration } from './icons/ic-integration.js';
import { IcIntelligence } from './icons/ic-intelligence.js';
import { IcInventory } from './icons/ic-inventory.js';
import { IcInvestigate } from './icons/ic-investigate.js';
import { IcIot } from './icons/ic-iot.js';
import { IcJobs } from './icons/ic-jobs.js';
import { IcLicensing } from './icons/ic-licensing.js';
import { IcList } from './icons/ic-list.js';
import { IcMagnet } from './icons/ic-magnet.js';
import { IcMaintenance } from './icons/ic-maintenance.js';
import { IcMerakiInsight } from './icons/ic-meraki-insight.js';
import { IcMobileDeviceSecurity } from './icons/ic-mobile-device-security.js';
import { IcMonitor } from './icons/ic-monitor.js';
import { IcMultiFactorAuth } from './icons/ic-multi-factor-auth.js';
import { IcMulticloud } from './icons/ic-multicloud.js';
import { IcNetworkDevices } from './icons/ic-network-devices.js';
import { IcNetworkSwitcher } from './icons/ic-network-switcher.js';
import { IcNetworkWide } from './icons/ic-network-wide.js';
import { IcNonCiscoHostedFabrics } from './icons/ic-non-cisco-hosted-fabrics.js';
import { IcObjects } from './icons/ic-objects.js';
import { IcOperations } from './icons/ic-operations.js';
import { IcOrganization } from './icons/ic-organization.js';
import { IcOrganizationSwitcher } from './icons/ic-organization-switcher.js';
import { IcOutbreakControl } from './icons/ic-outbreak-control.js';
import { IcOverview } from './icons/ic-overview.js';
import { IcPlaceholder } from './icons/ic-placeholder.js';
import { IcPolicies } from './icons/ic-policies.js';
import { IcPredictiveNetworks } from './icons/ic-predictive-networks.js';
import { IcProvisioning } from './icons/ic-provisioning.js';
import { IcRemoteSessions } from './icons/ic-remote-sessions.js';
import { IcReportsIcon } from './icons/ic-reports-icon.js';
import { IcResources } from './icons/ic-resources.js';
import { IcRolesAndPermissions } from './icons/ic-roles-and-permissions.js';
import { IcSamples } from './icons/ic-samples.js';
import { IcSecureConnect } from './icons/ic-secure-connect.js';
import { IcSecurity } from './icons/ic-security.js';
import { IcSensors } from './icons/ic-sensors.js';
import { IcServers } from './icons/ic-servers.js';
import { IcServiceSwitcher } from './icons/ic-service-switcher.js';
import { IcSettings } from './icons/ic-settings.js';
import { IcSites } from './icons/ic-sites.js';
import { IcSoftware } from './icons/ic-software.js';
import { IcSso } from './icons/ic-sso.js';
import { IcSubmit } from './icons/ic-submit.js';
import { IcSubscriptions } from './icons/ic-subscriptions.js';
import { IcSuite } from './icons/ic-suite.js';
import { IcSwitching } from './icons/ic-switching.js';
import { IcSystemsManager } from './icons/ic-systems-manager.js';
import { IcTags } from './icons/ic-tags.js';
import { IcTeleworkerGateway } from './icons/ic-teleworker-gateway.js';
import { IcThreats } from './icons/ic-threats.js';
import { IcTools } from './icons/ic-tools.js';
import { IcTopology } from './icons/ic-topology.js';
import { IcUplink } from './icons/ic-uplink.js';
import { IcUsers } from './icons/ic-users.js';
import { IcViews } from './icons/ic-views.js';
import { IcVpn } from './icons/ic-vpn.js';
import { IcWireless } from './icons/ic-wireless.js';
import { IcWorkflows } from './icons/ic-workflows.js';

const navIconMap = {
  "access-management": IcAccessManagement,
  activities: IcActivities,
  admin: IcAdmin,
  agents: IcAgents,
  alerts: IcAlerts,
  analytics: IcAnalytics,
  applications: IcApplications,
  assurance: IcAssurance,
  bookmarks: IcBookmarks,
  cameras: IcCameras,
  "cellular-gateway": IcCellularGateway,
  "change-log": IcChangeLog,
  "change-window-notifications": IcChangeWindowNotifications,
  configuration: IcConfiguration,
  connect: IcConnect,
  "context-visibility": IcContextVisibility,
  "create-fabric": IcCreateFabric,
  design: IcDesign,
  destinations: IcDestinations,
  documentation: IcDocumentation,
  domains: IcDomains,
  endpoints: IcEndpoints,
  "enterprise-name": IcEnterpriseName,
  explore: IcExplore,
  fabrics: IcFabrics,
  feedback: IcFeedback,
  filters: IcFilters,
  firewall: IcFirewall,
  firmware: IcFirmware,
  "generate-token": IcGenerateToken,
  "global-overview": IcGlobalOverview,
  groups: IcGroups,
  help: IcHelp,
  home: IcHome,
  identity: IcIdentity,
  indicator: IcIndicator,
  integration: IcIntegration,
  intelligence: IcIntelligence,
  inventory: IcInventory,
  investigate: IcInvestigate,
  iot: IcIot,
  jobs: IcJobs,
  licensing: IcLicensing,
  list: IcList,
  magnet: IcMagnet,
  maintenance: IcMaintenance,
  "meraki-insight": IcMerakiInsight,
  "mobile-device-security": IcMobileDeviceSecurity,
  monitor: IcMonitor,
  "multi-factor-auth": IcMultiFactorAuth,
  multicloud: IcMulticloud,
  "network-devices": IcNetworkDevices,
  "network-switcher": IcNetworkSwitcher,
  "network-wide": IcNetworkWide,
  "non-cisco-hosted-fabrics": IcNonCiscoHostedFabrics,
  objects: IcObjects,
  operations: IcOperations,
  organization: IcOrganization,
  "organization-switcher": IcOrganizationSwitcher,
  "outbreak-control": IcOutbreakControl,
  overview: IcOverview,
  placeholder: IcPlaceholder,
  policies: IcPolicies,
  "predictive-networks": IcPredictiveNetworks,
  provisioning: IcProvisioning,
  "remote-sessions": IcRemoteSessions,
  "reports-icon": IcReportsIcon,
  resources: IcResources,
  "roles-and-permissions": IcRolesAndPermissions,
  samples: IcSamples,
  "secure-connect": IcSecureConnect,
  security: IcSecurity,
  sensors: IcSensors,
  servers: IcServers,
  "service-switcher": IcServiceSwitcher,
  settings: IcSettings,
  sites: IcSites,
  software: IcSoftware,
  sso: IcSso,
  submit: IcSubmit,
  subscriptions: IcSubscriptions,
  suite: IcSuite,
  switching: IcSwitching,
  "systems-manager": IcSystemsManager,
  tags: IcTags,
  "teleworker-gateway": IcTeleworkerGateway,
  threats: IcThreats,
  tools: IcTools,
  topology: IcTopology,
  uplink: IcUplink,
  users: IcUsers,
  views: IcViews,
  vpn: IcVpn,
  wireless: IcWireless,
  workflows: IcWorkflows
};

export { navIconMap };
//# sourceMappingURL=nav-icon-map.js.map
